import React from 'react';
import logoImage from '../../assets/logo_150.png';

const Logo = () => <img src={logoImage} className="logo" alt="CS" />;

export default Logo;
